import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, LazyImport } from 'owa-bundling-light';
export {
    default as onAcquisitionsRefreshed,
    type OnAcquisitionsRefreshedActionMessage,
} from './actions/onAcquisitionsRefreshed';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaM365Acquisitions" */ './lazyIndex'),
    { name: 'OwaM365Acquisitions' }
);

export const lazyGetM365Acquisitions: LazyAction<
    typeof lazyIndex.getM365Acquisitions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getM365Acquisitions);
export const lazyGetM365AcquisitionsWithSource: LazyAction<
    typeof lazyIndex.getM365AcquisitionsWithSource,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getM365AcquisitionsWithSource);
export const lazyAcquireAndPinM365App: LazyAction<
    typeof lazyIndex.acquireAndPinM365App,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.acquireAndPinM365App);
export const lazyGetM365Acquisition: LazyAction<
    typeof lazyIndex.getM365Acquisition,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getM365Acquisition);
export const lazyIsAddInAppStoreEnabled: LazyImport<
    typeof lazyIndex.isAddInAppStoreEnabled,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.isAddInAppStoreEnabled);
export const lazyUninstallM365Acquisition: LazyAction<
    typeof lazyIndex.uninstallM365Acquisition,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.uninstallM365Acquisition);
export const lazyQueueAcquisitionsNetworkCall: LazyAction<
    typeof lazyIndex.queueAcquisitionsNetworkCall,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.queueAcquisitionsNetworkCall);
export const lazyAddMessageExtensionToReadSurfaceActionsMutator: LazyAction<
    typeof lazyIndex.addMessageExtensionToReadSurfaceActionsMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addMessageExtensionToReadSurfaceActionsMutator);
export const lazyAddMessageExtensionToComposeSurfaceActionsMutator: LazyAction<
    typeof lazyIndex.addMessageExtensionToComposeSurfaceActionsMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addMessageExtensionToComposeSurfaceActionsMutator);
export const lazyRemoveMessageExtensionFromSurfaceActionsMutator: LazyAction<
    typeof lazyIndex.removeMessageExtensionFromSurfaceActionsMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeMessageExtensionFromSurfaceActionsMutator);
export const lazyAddAddinNetworkLogs: LazyAction<
    typeof lazyIndex.addAddinNetworkLogs,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addAddinNetworkLogs);
